module.exports = __webpack_public_path__ + "static/media/aig_logo.110ea779.png";